import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OffersConfigService {

  private _apiBaseUrl: string = '';

  public constructor(private appService: AppService, public http: HttpClient, @Inject('API_BASE_URL') baseurl: string) {
    this._apiBaseUrl = baseurl;
  }

  public getOffers = (HasOffers: boolean): Observable<any> => {
    const apipath: string = 'offersetting/creditor?HasOffer='+HasOffers;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public getTransactionType = (): Observable<any> => {
    const apipath: string = 'offersetting/transaction-type';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }  

  public getFrequencyListByCreditor = (CreditorId: string): Observable<any> => {
    const apipath: string = 'offersetting/frequency/'+CreditorId;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public updateOffersOfferStatus = (Id: number, IsActive: number): Observable<any> => {
    const apipath: string = 'offersetting/offer-status';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { Id: Id, IsActive: IsActive};

    return this.http.put<any>(fullPath, params, options);
  }

  public updateCreditorOfferStatus = (Id: any, IsActive: number): Observable<any> => {
    const apipath: string = 'offersetting/update-creditor-offer-status';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { CreditorId: Id, IsOfferSettingEnabled: IsActive};

    return this.http.put<any>(fullPath, params, options);
  }

  public updateOffersOffer = (data: any): Observable<any> => {
    const apipath: string = 'offersetting/update-offer';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = data;

    return this.http.put<any>(fullPath, params, options);
  }

  public createOffersOffer = (data: any): Observable<any> => {
    const apipath: string = 'offersetting/create-offer';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = data;

    return this.http.post<any>(fullPath, params, options);
  }

    public getListOffersByCreditor = (CreditorId: string): Observable<any> => {
    const apipath: string = `offersetting/list-offer/${CreditorId}`;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public deleteOffersById = (id: number): Observable<any> => {
    const apipath: string = `offersetting/delete-offerd/${id}`;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.delete<any>(fullPath, options);
  }

}